import { Component } from '@angular/core';
import { AuthService } from './core/auth/auth.service';
import { ApplicationLanguageService } from './core/i18n/application-language.service';
import { GroupProxy, PracticeProxy } from './shared/proxies';

@Component({
    selector: 'add-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    constructor(public authService: AuthService, practiceProxy: PracticeProxy, groupProxy: GroupProxy, applicationLanguageService: ApplicationLanguageService) {
        authService.userInfo$.subscribe(async (userInfo) => {
            document.body.classList.toggle('admin', userInfo.isAdmin === true);

            // The angular application bundles are served aot compiled per language.
            // After login, check whether a redirect to the appropriate language is required.
            if (userInfo.isLoggedIn !== true) {
                return;
            }

            if (userInfo.isAdmin) {
                applicationLanguageService.loadForLanguage('nl');
            } else if (userInfo.isGroupManager) {
                const groupDetails = await groupProxy.getGroup(userInfo.groupId);
                applicationLanguageService.loadForLanguage(groupDetails.language);
            } else {
                const practiceDetails = await practiceProxy.getPractice(userInfo.practiceId);
                applicationLanguageService.loadForLanguage(practiceDetails.language);
            }
        });
    }
}
